import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './hooks/useAuth';

// Pages
import LoginPage from './pages/auth/LoginPage';
import { SalesProvider } from './contexts/SalesContext';
import DashboardHome from './pages/dashboard/DashboardHome';
import VirtualModelPage from './pages/virtualModel/VirtualModelPage';
import SalesFlowPage from './pages/sales/SalesFlowPage';

// Novas páginas importadas
import FinancialPage from './pages/financial/FinancialPage';
import SchedulePage from './pages/calendar/SchedulePage';
import InventoryPage from './pages/inventory/InventoryPage';
import CampaignsPage from './pages/backoffice/CampaignsPage';

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  // Show loading state while checking authentication
  if (loading) {
    return <div className="flex h-screen items-center justify-center">Carregando...</div>;
  }
  
  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

// App content with routes
const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      
      {/* Protected routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <DashboardHome />
        </ProtectedRoute>
      } />
      
      <Route path="/virtual-model" element={
        <ProtectedRoute>
          <VirtualModelPage />
        </ProtectedRoute>
      } />
      
      <Route path="/sales/flow" element={
        <ProtectedRoute>
          <SalesProvider>
            <SalesFlowPage />
          </SalesProvider>
        </ProtectedRoute>
      } />
      
      {/* Rotas de Inventário */}
      <Route path="/inventory" element={
        <ProtectedRoute>
          <InventoryPage />
        </ProtectedRoute>
      } />
      
      {/* Rotas Financeiras */}
      <Route path="/financial/payments" element={
        <ProtectedRoute>
          <FinancialPage />
        </ProtectedRoute>
      } />
      
      <Route path="/financial/commissions" element={
        <ProtectedRoute>
          <FinancialPage />
        </ProtectedRoute>
      } />
      
      {/* Rotas de Clientes */}
      {/* <Route path="/customers" element={
        <ProtectedRoute>
          <CustomersPage />
        </ProtectedRoute>
      } /> */}
      
      {/* Rotas de Backoffice */}
      <Route path="/backoffice/campaigns" element={
        <ProtectedRoute>
          <SalesProvider>
          <CampaignsPage />
          </SalesProvider>
        </ProtectedRoute>
      } />
      
      {/* Rotas de Agenda */}
      <Route path="/schedule" element={
        <ProtectedRoute>
          <SchedulePage />
        </ProtectedRoute>
      } />
      
      {/* Rota para propostas e contratos */}
      {/* <Route path="/sales/proposals" element={
        <ProtectedRoute>
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">Propostas</h1>
            <p>Página de propostas em desenvolvimento</p>
          </div>
        </ProtectedRoute>
      } /> */}
      
      {/* <Route path="/sales/contracts" element={
        <ProtectedRoute>
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">Contratos</h1>
            <p>Página de contratos em desenvolvimento</p>
          </div>
        </ProtectedRoute>
      } /> */}
      
      {/* Redirect root to dashboard */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      
      {/* Fallback route for 404 */}
      <Route path="*" element={
        <div className="flex h-screen items-center justify-center">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Página em desenvolvimento</h1>
            <p className="text-gray-600 mb-8">Em breve estará funcional</p>
            <a href="/dashboard" className="px-4 py-2 bg-blue-900 text-white rounded-md">
              Voltar para o Dashboard
            </a>
          </div>
        </div>
      } />
    </Routes>
  );
};

// Root app component with providers
const App = () => {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
};

export default App;